interface Props {
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
}